import { z } from 'zod'
import i18n from '@/utils/translations'
import { parse } from 'date-format-parse'

export const schemaVisaPAN = z
  .string({
    required_error: i18n.t('credit-card-err'),
    invalid_type_error: i18n.t('credit-card-err'),
  })
  .regex(/^4[0-9]{12}(?:[0-9]{3})?$/, {
    message: i18n.t('credit-card-err'),
  })

export const schemaMastercardPAN = z
  .string({
    required_error: i18n.t('credit-card-err'),
    invalid_type_error: i18n.t('credit-card-err'),
  })
  .regex(/^(2|5)[1-5][0-9]{14}$/, {
    message: i18n.t('credit-card-err'),
  })

export const schemaAmexPAN = z
  .string({
    required_error: i18n.t('credit-card-err'),
    invalid_type_error: i18n.t('credit-card-err'),
  })
  .regex(/^3[47][0-9]{13}$/, {
    message: i18n.t('credit-card-err'),
  })

export const schemaCreditCardPAN = z.union(
  [schemaVisaPAN, schemaMastercardPAN, schemaAmexPAN],
  {
    required_error: i18n.t('credit-card-init'),
    invalid_type_error: i18n.t('credit-card-err'),
  },
)

export function schemaCreditCardExpiry(format: string) {
  return z.string().refine(
    (value) => {
      const valueAsDate = parse(value, format)
      const currentDate = new Date()

      // Check if the format is valid
      if (isNaN(valueAsDate.getTime())) {
        return false
      }

      // Check if credit card has expired
      if (valueAsDate.getTime() < currentDate.getTime()) {
        return false
      }

      return true
    },
    {
      message: i18n.t('credit-card-exp-err'),
    },
  )
}

export const schemaCreditCardCVV = z.string().regex(/^\d{3}$/, {
  message: i18n.t('credit-card-cvv-err'),
})
